"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var StickyCvAreaController = /** @class */ (function (_super) {
    __extends(StickyCvAreaController, _super);
    function StickyCvAreaController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initialize = function () {
            if (!_this.containerTarget || !_this.stickyTarget) {
                return;
            }
            // stimulus の target-action に scroll が無いため initialize で設定
            window.addEventListener('scroll', _this.scroll);
            _this.scroll();
        };
        _this.scroll = function () {
            if (!_this.containerTarget || !_this.stickyTarget) {
                return;
            }
            if (_this.element.getBoundingClientRect().top < 100) {
                _this.stickyTarget.style.height = "".concat(_this.containerTarget.scrollHeight, "px");
            }
            else {
                _this.stickyTarget.style.height = '0';
            }
        };
        return _this;
    }
    StickyCvAreaController.targets = ['container', 'sticky'];
    return StickyCvAreaController;
}(stimulus_1.Controller));
exports.default = StickyCvAreaController;
